<div class="lucky-box">

    <!-- Reveal: cupon flotante + boton adquirir -->
    <ng-container *ngIf="showReveal">
        <div class="lucky-reveal">
            <div class="floating-ticket">
                <div class="floating-ticket-inner">
                    <img *ngIf="coupon?.imageUrl || coupon?.thumbnailUrl" [src]="coupon?.imageUrl || coupon?.thumbnailUrl" class="ticket-img" alt="">
                    <i *ngIf="!coupon?.imageUrl && !coupon?.thumbnailUrl" class="mdi mdi-gift-outline placeholder-icon"></i>
                </div>
                <div class="floating-ticket-shine"></div>
            </div>

            <div class="reveal-name">{{ coupon?.name }}</div>

            <button class="btn-adquirir" type="button" (click)="onClaimGiveaway()">
                Adquirir
            </button>
        </div>
    </ng-container>

    <!-- Antes del reveal: encabezado + area plateada -->
    <ng-container *ngIf="!showReveal">

        <div class="lucky-box-title">
            <span>¡Raspa aquí!</span>
            <i class="mdi mdi-gesture-tap wiggle"></i>
        </div>

        <div class="lucky-box-subtitle">
            Usa tu dedo para descubrir el premio
        </div>

        <div class="silver-wrap">
            <!-- Contenido debajo (premio o mas suerte) -->
            <div class="silver-content">
                <ng-container *ngIf="isWinner && coupon">
                    <div class="win-title">¡Ganaste!</div>
                    <div class="win-name">{{ coupon?.name }}</div>
                    <img *ngIf="coupon?.thumbnailUrl" [src]="coupon?.thumbnailUrl" class="win-thumb" alt="">
                </ng-container>
                <ng-container *ngIf="!isWinner">
                    <img src="assets/images/mas_suerte.gif" class="lose-anim" alt="">
                </ng-container>
            </div>

            <!-- Capa raspable -->
            <canvas #scratcherCanvas class="scratcher-canvas" *ngIf="!hideCanvas"></canvas>

            <!-- Brillo animado (sheen) mientras no raspa -->
            <div class="sheen" *ngIf="firstScratch && !hideCanvas"></div>
        </div>

        <!-- El premio no se pudo registrar: sin esto quedaba raspado y sin botón -->
        <div class="claim-error" *ngIf="claimError">{{ claimError }}</div>
    </ng-container>
</div>
